import { render, staticRenderFns } from "./FormulatingFoundationsForm.vue?vue&type=template&id=ea9dda36&"
import script from "./FormulatingFoundationsForm.vue?vue&type=script&lang=js&"
export * from "./FormulatingFoundationsForm.vue?vue&type=script&lang=js&"
import style0 from "./FormulatingFoundationsForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)


    import installComponents from "!/Users/leandrosehnembortolotto/Development/Dropsmart/dropsmith-frontend-v2/node_modules/bootstrap-vue-loader/lib/runtime/installComponents.js"
    import {BFormInput, BFormInvalidFeedback, BInputGroup, BAlert, BSpinner, BForm, BModal, BCol, BFormSelect, BRow, BCardText, BCard, BFormCheckbox, BFormGroup, BInputGroupPrepend, BToast, BPopover, BContainer} from 'bootstrap-vue'
    installComponents(component, {BFormInput, BFormInvalidFeedback, BInputGroup, BAlert, BSpinner, BForm, BModal, BCol, BFormSelect, BRow, BCardText, BCard, BFormCheckbox, BFormGroup, BInputGroupPrepend, BToast, BPopover, BContainer})
    


    import installDirectives from "!/Users/leandrosehnembortolotto/Development/Dropsmart/dropsmith-frontend-v2/node_modules/bootstrap-vue-loader/lib/runtime/installDirectives.js"
    import {VBModal} from 'bootstrap-vue'
    installDirectives(component, {'b-modal': VBModal})
    

export default component.exports